import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
  minutes: number;
};
const NAMES = ['Valentina', 'Mateo', 'Camila', 'Lucía', 'Martín', 'Sofía', 'Julián', 'Florencia', 'Tomás', 'Agustina', 'Joaquín', 'Micaela', 'Brenda', 'Gonzalo', 'Rocío', 'Federico'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán', 'Neuquén', 'Bariloche', 'Santa Fe', 'Resistencia', 'Posadas', 'San Juan', 'Paraná', 'Bahía Blanca'];
const randomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
const buildPurchase = (): Purchase => ({
  name: randomItem(NAMES),
  city: randomItem(CITIES),
  minutes: Math.floor(Math.random() * 14) + 1
});
export const PurchasePopups = () => {
  const [current, setCurrent] = useState<Purchase | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setCurrent(buildPurchase());
      hideTimeout = setTimeout(() => setCurrent(null), 5500);
    };
    // First popup after a short delay, then repeat
    const firstTimeout = setTimeout(showOne, 4000);
    const interval = setInterval(showOne, 11000);
    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <div aria-live="polite" className="fixed bottom-3 left-3 z-50 max-w-[calc(100vw-1.5rem)] sm:max-w-[18rem] pointer-events-none" data-id="element-197">
      <AnimatePresence mode="wait" data-id="element-198">
        {current && <motion.div key={`${current.name}-${current.city}-${current.minutes}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-2.5 bg-celestial-800/95 backdrop-blur-md border border-gold/30 rounded-xl p-2 pr-7 shadow-[0_10px_40px_rgba(0,0,0,0.5)] relative" data-id="element-199">
            <div className="w-7 h-7 flex-shrink-0 rounded-full bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center shadow-[0_0_15px_rgba(212,175,55,0.35)]" data-id="element-200">
              <Sparkles className="w-3.5 h-3.5 text-celestial-900" data-id="element-201" />
            </div>
            <div className="min-w-0" data-id="element-202">
              <p className="text-xs text-indigo-100/90 leading-snug" data-id="element-203">
                <span className="text-gold-light font-medium" data-id="element-204">
                  {current.name}
                </span>{' '}
                de {current.city} accedió a la Formación
              </p>
              <p className="text-[10px] text-indigo-100/50 uppercase tracking-wider mt-0.5" data-id="element-205">
                Hace {current.minutes} min · Verificada
              </p>
            </div>
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="absolute top-1.5 right-1.5 text-indigo-100/40 hover:text-gold transition-colors focus:outline-none focus:text-gold" data-id="element-206">
              <X className="w-3.5 h-3.5" data-id="element-207" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
};